import { OwnAdministrativeFeeDto } from './ownadministrativefeedto';
import { pageDto } from './pagedto';

export class OwnAdministrativeFeeResponse {

    listOwnAdministrativeFeeDto: OwnAdministrativeFeeDto[] = [];

    pageDto: pageDto = new pageDto({});
}